<label class="switch" [class.switch--checked]='isChecked' [class.switch--disabled]='isDisabled' (click)='toggle()'>
    <span class="slider round"></span>
</label>
